var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3"},[_c('div',{staticClass:"col-xs-12 col-md-12 text-center"},[_c('button',{staticClass:"btn btn-sm capitalize",on:{"click":_vm.print}},[_vm._v(_vm._s(_vm.buttontext))])]),_vm._v(" "),_c('div',{staticClass:"text-sm printablehandout",attrs:{"id":_vm.name}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }